import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { FormState } from '../../models/FormState';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
  @Input() state: FormState;
  @Input() headerText: string;
  @Input() bodyText: string;
  @Input() bodyTemplate: TemplateRef<any>;
  @Input() confirmButtonText: string;
  @Output() confirmationResult = new EventEmitter<boolean>();
  @Output() closeModal = new EventEmitter();
  errorResponse: HttpErrorResponse;
  formStates = FormState;

  constructor(public activeModal: NgbActiveModal) {}

  onConfirm() {
    this.confirmationResult.emit(true);
  }

  onClose(val: string) {
    this.closeModal.emit();
    this.activeModal.close(val);
  }
}
